import { useEffect, useState } from "react";
import ghflag from "./images/ghanaflag.png";
import Createanouncement from "./Createanouncement";
import Approvals from "./Approvals";
import Createevent from "./CreateEvent";
import { realtimeDB } from "./Backend";
import { Cancel } from "@mui/icons-material";
import { onValue, ref, set } from "firebase/database";
import adminbannerimage from "./images/adminbannerimg2.jpg";
import Overview from "./Overview";
import WebrtcAxios from "./fetchApi/WebrtcAxios";
import { sanitizeText } from "./utilityClass";

   

const Sidecontents = ({profilepane, livesession, statssession, anouncementsession, approvalsession, eventsession, overviewdetails}) => {

    const[adminName,setAdminname]=useState("");
    const[adminEmail,setAdminemail]=useState("");
    const[adminLocation,setAdminlocation]=useState("");
    const[success,setSuccessMessage]=useState(false);
    const[commentStatus,setCommentStatus]=useState("");
    // const[zionStatus,setZionStatus]=useState("");
    const[guests,setGuests]=useState("");
    // const[Visits,setVisits]=useState([]);
    const[todayVisits,setTodayvisits]=useState("");
    const[yearvisits,setYearvisits]=useState("");
    const [create_admin_name, setCreateAdminName]=useState("");
    const [create_admin_pwd, setCreateAdminPwd]=useState("");
    const [programTitle, setProgramTitle] = useState("");
   
    // const now = Timestamp.now();
    // const datejoined = new Date(now?.toDate()).toUTCString();
    const timestamp = new Date().getTime(); 
    // const today = new Date();
    // const formattoday = format(today,"yyyy-MM-dd");
   
    const submitAdminInfo = async(e)=>{
        e.preventDefault();
        try{
            set(ref(realtimeDB, `adminvisits/${sanitizeText(adminEmail)}`),{
                adminName,
                adminEmail,
                adminLocation,
                guests,
                timestamp,
            });
            setSuccessMessage(true);
            localStorage.setItem("user_id",adminEmail);
            localStorage.setItem("name_id",adminName+" (host)");
            localStorage.setItem("location_id",adminLocation);
        }catch(err){
            console.log(err);
        }       
    };

    const submitProgramTitle= async (e) => {
        e.preventDefault();
        set(ref(realtimeDB, `adminProgram`), `${programTitle}${timestamp}`);
        setSuccessMessage(true);
    };

    useEffect(()=>{
        onValue(ref(realtimeDB,"commentsession2"),(snapshot)=>{
            if(snapshot.val()==="disable"){
                setCommentStatus("Disabled");
            }else {
                setCommentStatus("Enabled");
            }
        });

        // onValue(ref(realtimeDB,"zionmeeting2"),(snapshot)=>{
        //     if(snapshot.val()==="disconnect"){
        //         setZionStatus("Disconnected");
        //     }else {
        //         setZionStatus("Active");
        //     }
        // });

        const admin_email= localStorage.getItem("user_id");
        const admin_name = localStorage.getItem("name_id");
       const admin_location= localStorage.getItem("location_id");
          if(admin_email){
              setAdminemail(admin_email);
          }
          if(admin_name){
              setAdminname(admin_name);
          }
          if(admin_location){
              setAdminlocation(admin_location);
          }
    },[]);

    const handleCommentsettings=(e)=>{
        if(e.target.id==="disablecomment" && e.target.checked){
            set(ref(realtimeDB,"commentsession2"),"disable");
           setCommentStatus("Disabled");
        };
        if(e.target.id==="enablecomment"&& e.target.checked){
            set(ref(realtimeDB,"commentsession2"),process.env.REACT_APP_ENABLECOMMENT);
            setCommentStatus("Enabled");
        };
    };

    const addAdminDetailsToDB=async(e)=>{
        e.preventDefault();
        try {
         const res = await WebrtcAxios.post("/createadmin",
                JSON.stringify({userEmail: sanitizeText(create_admin_name), pwd: create_admin_pwd}),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            alert(`${res.data.success}`);
        } catch (err) {
            if (!err?.response) {
                alert("no server response");
              }else if (err?.response.status === 500) {
                alert("service unavailable at the moment");
              }else if (err?.response.status === 400) {
                alert("name or email and password required");
              }else{
                  alert("an unknown error occurred. report issue to developers");
              }
        }
    };

    // const handleZionsettings=(e)=>{
    //     if(e.target.id==="enablezion" && e.target.checked){
    //         set(ref(realtimeDB,"zionmeeting2"),process.env.REACT_APP_CONNECT);
    //         setZionStatus("Active");
    //     };
    //     if(e.target.id==="disablezion"&& e.target.checked){
    //         set(ref(realtimeDB,"zionmeeting2"),"disconnect");
    //         setZionStatus("Disconnected");
    //     };
    // };

    // useEffect(()=>{
    //     const collectionref = collection(db,"users");
    //     const q = query(collectionref,orderBy("timestamp","asc"));
    //     try{
    //         const unsub = onSnapshot(q,(snapshot)=>{
    //              const getdata = [];
    //              snapshot.forEach((doc)=>{
    //                  getdata.push(doc.data());
    //              });
    //              setVisits(getdata);
    //         });
    //          return unsub;
    //      }catch(err){
    //          console.log(err);
    //      }
    // },[]);


    return (  
        <div className="adminfeedcontent flex-column2" >
            {overviewdetails && 
                     <div className="welcome-home flex-row2"
                     style={{backgroundImage:`url(${adminbannerimage})`,backgroundPosition:"center",backgroundSize:"100%",caretColor:"transparent"}}>
                     <h1 style={{color:"white",backgroundColor:"#00000050",fontFamily:"sans-serif"}}>Horemow Ghana Admin Dashboard</h1>
                     <img src={ghflag} alt="ghana flag" style={{width:"400px"}}/>
                     </div>
            }
       
            {
                profilepane &&
                <div className="adminprofile flex-column1">
                    <form className="admindetails" onSubmit={submitAdminInfo}>
                        <input type="text" placeholder="Admin Name"  value={adminName} onChange={(e)=>setAdminname(e.target.value)} /> <br/>
                        <input type="text" placeholder="enter email or telephone"  value={adminEmail} onChange={(e)=>setAdminemail(e.target.value)} /> <br/>
                        <input type="text" placeholder="enter your unit or chapter location" value={adminLocation} onChange={(e)=>setAdminlocation(e.target.value)}/> <br/>
                        <input type="text" placeholder="Guest speaker name(s)" value={guests} onChange={(e)=>setGuests(e.target.value)}/> <br/><br/><br/>
                        <label >host speaker details</label>  <br/>
                        <input type="text" placeholder="host name" readOnly value={adminName} onChange={(e)=>setAdminname(e.target.value)}/><br/>
                        <input type="text" placeholder="host location" readOnly value={adminLocation} onChange={(e)=>setAdminlocation(e.target.value)} /> <br/>
                        <input type="text" placeholder="program title" value={programTitle} onChange={(e)=>setProgramTitle(e.target.value)} /> <br/>
                        <label>Guests for the Program</label>
                        <input type="text" placeholder="No Guest yet" readOnly value={guests} onChange={(e)=>setGuests(e.target.value)}/><br/><br/>
                        <button className="buttonstyle" style={{backgroundColor:"#0B65DA", color:"white",}}>
                            Submit
                        </button>
                    </form>

                    <form className="create-admin" onSubmit={addAdminDetailsToDB}>
                        <fieldset>
                            <legend>Admin name or email</legend>
                            <input type="text" required placeholder="admin name" value={create_admin_name} onChange={e => setCreateAdminName(e.target.value)}/>
                        </fieldset>

                        <fieldset>
                            <legend>password</legend>
                            <input type="password" required placeholder="password" value={create_admin_pwd} onChange={e => setCreateAdminPwd(e.target.value)}/>
                        </fieldset>
                        
                        <button className="buttonstyle" style={{backgroundColor:"#0B65DA", color:"white",}}>
                            Create
                        </button>
                    </form>

                    <form className="admin-program-title" onSubmit={submitProgramTitle}>
                        <fieldset>
                            <legend>Program Title</legend>
                            <input type="text" required placeholder="program title" value={programTitle} onChange={e => setProgramTitle(e.target.value)}/>
                        </fieldset>
                        
                        <button className="buttonstyle" style={{backgroundColor:"#0B65DA", color:"white"}}>
                            Add program
                        </button>
                    </form>
                </div>
            }
           
           {
            livesession &&
            <div className="livesettings">
            <div className="commentsettings">
                    <h2 style={{color:"black",fontWeight:"bold",backgroundColor:"white"}}>
                        Comment session <br/> Double click to select an option.
                    </h2>
                  
                    <form className="flex-column2" style={{gap:"10px"}}> 
                    <div className="flex-row2">
                    <input type="radio" id="enablecomment" name="comment" onChange={handleCommentsettings} />
                    <label htmlFor="enablecomment">Enable</label>
                    </div>
                  
                    <div className="flex-row2">
                    <input type="radio" id="disablecomment" name="comment" onChange={handleCommentsettings}/>
                    <label htmlFor="disablecomment">Disable Comments</label>
                    </div>
                    </form>

                    <h3>Status: {commentStatus}</h3>
                 
                    <p style={{color:"black",fontWeight:"bold"}}>By default comment session is enabled for live programs.
                        you can either disable or enable based on your program
                        structure.
                    </p>
            </div> 

            {/* <div className="zionmeetingsettings2">
                    <h2 style={{color:"white",fontWeight:"bold",backgroundColor:"black"}}>
                        Would you stream on zion meeting?<br/> Double click to select an option.
                    </h2>
        
                    <form className="flex-column2" style={{gap:"10px"}}> 
                    <div className="flex-row2">
                    <input type="radio" id="enablezion" name="zion" onChange={handleZionsettings} />
                    <label htmlFor="enablezion">Yes</label>
                    </div>
                  
                    <div className="flex-row2">
                    <input type="radio" id="disablezion" name="zion" onChange={handleZionsettings}/>
                    <label htmlFor="disablezion">No</label>
                    </div>
                    </form>

                    <h3>Status: {zionStatus}</h3>
                
                    <p style={{color:"white",fontWeight:"bold"}}>Any selection you do will notify your users on whether 
                        zion meeting will be used or not. This will avoid users from 
                        joining empty meeting sessions.
                    </p>
            </div> */}
            </div>
           }
           {
            overviewdetails &&
             <Overview/>
           }
            
            
            {statssession&&
            <div className="statsession">
                    {/* {Visits && Visits.filter((data)=>{
                        if(todayVisits === ""){
                            return true;
                        }else if(data.todayVisits.toLowerCase().replace(/[^\w\s]|_/g, '').includes(todayVisits.toLowerCase().replace(/[^\w\s]|_/g, ''))){
                            return true;
                        }
                        return false
                    }).map(m =>(
                    <div className="arrangeVisitsData" key={m.timestamp}>
                        <h3>Name: {m.username}</h3>
                        <p style={{fontWeight:"bold",fontFamily:"sans-serif"}}>
                            Checked In: {m.current_date}
                        </p>
                        <h2>Location: {m.unitLocation}</h2>
                        {m.contact && <h3>Contact: {m.contact}</h3>}
                    </div>
                ))} */}

                <div className="statsqueryfield flex-column2">
                <fieldset>
                    <legend>Today Visits</legend>
                    <input type="date" value={todayVisits} onChange={e => setTodayvisits(e.target.value)}/>
                </fieldset>

                <fieldset>
                    <legend>Year</legend>
                    <form className="flex-row2">
                        <input type="text" value={yearvisits} onChange={e => setYearvisits(e.target.value)} />
                        <button>change</button>
                    </form>
                </fieldset>
                </div>
              
            </div>
            
            }
            
            {
                anouncementsession&&
                <Createanouncement/>
            }
            {
                approvalsession&&
                <Approvals/>
            }
            {
                eventsession&&
                <Createevent/>
            }
           
           {
            success &&
            <div className="toast">
                <h2 style={{color:"white",fontWeight:"bold"}}>Details added successfully</h2> 
                <button onClick={()=>setSuccessMessage(false)}><Cancel/></button>
            </div>
           }
       
        </div>
    );
}
export default Sidecontents;